<!--
商品详情页底部

使用说明：

<ProductDetailFooter
 />


-->

<template>
  <div class="footer-outerwrap">
    <PromptGetPointModal
      ref="kubaoLotteryPrompt"
      :url="user.kubaoLotteryLoginUrl"
    />
    <div class="footer-wrap">
      <a href="javascript:;" class="cart-btn" @click="gotoCart">
        <Icon
          class="cart-icon"
          :img="require('../../assets/icon-product-cart.png')"
          size="contain"
        />
        <span class="cart-size" v-show="cartSize">{{ cartSize }}</span>
      </a>
      <template v-if="type == 1">
        <!--卡密-->
        <button
          href="javascript:;"
          class="m-button add-cart-btn"
          style="background: #fff"
        ></button>
        <button href="javascript:;" class="m-button buy-btn" @click="ToCharge">
          立即兑换
        </button>
      </template>
      <template v-else-if="type == 4">
        <!--黄金-->
        <button
          href="javascript:;"
          class="m-button add-cart-btn"
          style="background: #fff"
        ></button>
        <button
          href="javascript:;"
          class="m-button buy-btn"
          @click="addCart(true)"
        >
          立即兑换
        </button>
      </template>
      <template v-else>
        <button
          href="javascript:;"
          class="m-button add-cart-btn"
          @click="addCart(false)"
        >
          加入购物车
        </button>
        <button
          href="javascript:;"
          class="m-button buy-btn"
          @click="addCart(true)"
        >
          立即兑换
        </button>
      </template>

      <div class="cart-animate" id="J-cart-animate-icon"></div>
    </div>

    <bindPhoneDialog :visible.sync="visibleBindPhone"></bindPhoneDialog>
  </div>
</template>

<script>
import $ from "jquery";
import api from "../../api";
import store from "../../api/store";
import { IEVersion } from "../../tools/IEVersion/IEVersion";
import PromptGetPointModal from "@/components/kubaolottery/PromptGetPointModal";
// 绑定手机号
import bindPhoneDialog from "@/components/bindPhone/bindPhoneDialog";

export default {
  props: ["product", "type"],
  components: { PromptGetPointModal, bindPhoneDialog },
  data() {
    return {
      // 绑定手机号
      visibleBindPhone: false,

      cartSize: 0,
      skuId: null,
      easyUser: store.loginedUser.easyUser,
      user: {
        kkbUser: store.loginedUser.kkbUser,
        kubaoLotteryLoginUrl: store.loginedUser.kubaoLotteryLoginUrl,
      },
    };
  },
  methods: {
    ToCharge() {
      // 手机号绑定
      api.user.getPersonalInfo((user) => {
        store.loginedUser = user;
      });
      if (store.loginedUser.mustBindPhone && !store.loginedUser.phone)
        return (this.visibleBindPhone = true);

      if (this.easyUser) {
        // 大玩家用户
        console.log(this.product);
        this.$confirmDialog("确认兑换商品？", (btn) => {
          if (btn == "确定") {
            this.$showLoading("兑换中...");

            let machineSn = "";
            let pricePoint = this.product.price;
            let skuId = this.product.skuId;

            api.easy.easyOrderTakeVmall(
              pricePoint,
              skuId,
              (data) => {
                console.log(data);
                var hours = data.orderValidTimeMinute / 60;
                this.$confirmDialogWithOpts(
                  `提交订单成功,请在联系场地确认,超过${hours}小时未确认，订单将失效`,
                  "success",
                  ["我知道了", "查看订单"],
                  (btn) => {
                    if (btn == "我知道了") {
                      //Do nothing
                    } else if (btn == "查看订单") {
                      this.$routerReplace(this, "/pages/orders/List");
                    }
                  }
                );
                this.$hideLoading();
              },
              (err) => {
                console.log(err);

                this.$hideLoading();
                if (err.status == -1) {
                  this.$alertDialog(err.msg, () => {});
                } else {
                  this.$confirmDialogWithOpts(
                    "还有订单未确认，继续下单请确认或取消",
                    "error",
                    ["我知道了", "去订单管理"],
                    (btn) => {
                      if (btn == "我知道了") {
                        //Do nothing
                      } else if (btn == "去订单管理") {
                        //Do nothing
                        this.$routerReplace(this, "/pages/orders/List");
                      }
                    }
                  );
                }
              }
            );
          }
        });
      } else {
        //2.执行删除
        console.log(this.product);
        store.present = 0;

        this.$confirmDialog("确认兑换商品？", (btn) => {
          if (btn == "确定") {
            this.$showLoading("兑换中...");

            let machineSn = "";
            let pricePoint = this.product.price;
            let skuId = this.product.skuId;

            api.product.takeVmall(
              machineSn,
              pricePoint,
              skuId,
              (data) => {
                console.log(data);
                if (data.presentShredCount) {
                  store.present = data.presentShredCount;
                  var isIE = IEVersion();
                  if (isIE == "-1") {
                    // -1 表示非IE浏览器
                    this.$emit("showPrizeModal", data.presentShredCount);
                  }
                } else {
                  store.present = 0;
                }

                this.$showPurchaseDialog(() => {
                  this.$routerPush(this, "/pages/orders/Wallet");
                });
                this.$hideLoading();
              },
              (err) => {
                this.$hideLoading();

                if (
                  err.status == -46 &&
                  this.user.kkbUser &&
                  this.user.kubaoLotteryLoginUrl &&
                  this.$refs.kubaoLotteryPrompt.needNotify()
                ) {
                  //积分不足
                  this.$refs.kubaoLotteryPrompt.display();
                } else {
                  this.$alertDialog(err.msg);
                }
              }
            );
          }
        });
      }
    },
    loadData() {
      api.cart.getCartCount((data) => {
        this.cartSize = data.count;
      });
    },
    setSku(skuId) {
      this.skuId = skuId;
    },
    addCart(gotoCart) {
      if (gotoCart) {
        // 手机号绑定
        api.user.getPersonalInfo((user) => {
          store.loginedUser = user;
        });
        if (store.loginedUser.mustBindPhone && !store.loginedUser.phone)
          return (this.visibleBindPhone = true);
        //直接前往购买
        var num = this.product.steps.length > 0 ? this.product.steps[0] : 1;
        this.$router.push(
          "/pages/payment/payment?cart=" + this.skuId + "-" + num
        );
        return;
      }
      //展示动画
      $("#J-cart-animate-icon").addClass("active");
      setTimeout(() => {
        $("#J-cart-animate-icon").removeClass("active");
      }, 600);
      $("#J-cart-animate-icon").addClass("active");
      //请求服务器添加到数据库
      api.cart.addCart(
        this.skuId,
        1,
        false,
        (data) => {
          console.log(data);
          this.$toast("已添加到购物车");
          this.loadData();
        },
        (data) => {
          this.$toast(data.msg);
        }
      );
    },
    gotoCart() {
      this.$router.push("/pages/orders/Cart");
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
.footer-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  background: white;
  height: 17vw;
  font-size: 0;
  text-align: right;
  z-index: 2;
}

.cart-btn {
  display: inline-block;
  text-align: center;
  width: 34.4vw;

  .cart-icon {
    width: 7.73vw;
    height: 7.73vw;
    margin-top: 4.635vw;
    position: relative;
    z-index: 1;
  }

  .cart-size {
    @size: 4.8vw;
    position: absolute;
    z-index: 2;
    top: 3.4vw;
    left: 17.7vw;
    font-size: 2.4vw;
    text-align: center;
    border-radius: @size;
    background: #ff0129;
    color: #fff;
    min-width: @size;
    height: @size;
    line-height: 1em;
    box-sizing: border-box;
    vertical-align: bottom;
    padding-top: (@size - 2.4vw) / 2;
  }
}

.add-cart-btn,
.buy-btn {
  display: inline-block;
  font-size: 4.53vw;
  color: #fff;
  text-align: center;
  width: 32vw;
  height: 17vw;
  vertical-align: top;
  line-height: 17vw;
}

.add-cart-btn {
  background: linear-gradient(to right, #ffa740, #ff895f);
}

.buy-btn {
  background: linear-gradient(to right, #ff0129, #ff0129);
}

@keyframes cartAnimate {
  0% {
    transform: rotate(0deg);
    // transform: translate3d(0,0%,0);
    opacity: 0.9;
  }

  50% {
    // transform: translate3d(-16vw, -8vw,0);
  }

  to {
    // transform: translate3d( -32vw,0,0);
    opacity: 0.4;
    transform: rotate(-180deg);
  }
}

.cart-animate {
  @size: 3vw;
  width: @size;
  height: @size;
  background: #ff0129;
  border-radius: 50%;
  position: fixed;
  z-index: 10;
  left: 34vw + 32.8vw / 2;
  bottom: 8.5vw;
  opacity: 0.9;
  display: none;

  transform-origin: -14.4vw 0vw;

  &.active {
    display: block;
    animation-name: cartAnimate;
    animation-duration: 0.6s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.78, 0.28, 0.83, 0.42);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/products/ProductDetailFooter.vue